<template>
  <div class="popin" :class="{'is-active': isActive }">
    <div class="popin-container">
      <button type="button" @click="onClose" class="popin-close">
        <i class="ic ic-close"></i>
      </button>
      <div class="popin-content">
        <img :src="image" alt="">
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  @import "~@/soprasolar-project/assets/styles/popin";
</style>
<style lang="scss">
  body.is-popin-open {
    .viewer-element .header {
      z-index: 1;
    }
  }
</style>
<script>
import { gsap } from 'gsap/all';
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'popin-help',
  props: ['image'],
  components: {},

  data () {
    return {
      isActive: false,
      isLoading: false
    }
  },

  created() {},

  beforeDestroy() {
    document.body.classList.remove('is-popin-open');
  },

  mounted() {
    document.body.classList.add('is-popin-open');
    gsap.to(window, { duration: .3, scrollTo: 0, onComplete: () => {
      this.isActive = true;
    } });
  },

  methods: {
    onClose() {
      AppControlService.popinHelpToggle(false);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>